import { Box, Typography, Grid } from "@mui/material";
import { MouseEventHandler, ReactNode, useEffect, useState } from "react";
import { optionsCategoryStyleProps } from "../theme/main";

const getOpenMaxHeight = () =>
  typeof window === "undefined" ? 0 : Math.round(window.innerHeight * 0.7);

export type OptionsCategoryProps = {
  id: string;
  title: string;
  subTitles: string[];
  isOpen: boolean;
  onClick?: MouseEventHandler<HTMLDivElement>;
  children?: ReactNode;
};

export function OptionsCategory({
  id,
  title,
  subTitles,
  isOpen,
  onClick,
  children,
}: OptionsCategoryProps) {
  const [openMaxHeight, setOpenMaxHeight] = useState(getOpenMaxHeight);
  const {
    titleStyle,
    subTitleStyle,
    titleChildrenSpace,
    childrenSpace,
    ...categoryStyle
  } = optionsCategoryStyleProps;

  useEffect(() => {
    const handleResize = () => {
      setOpenMaxHeight(getOpenMaxHeight());
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Box id={id} sx={categoryStyle}>
      <Box onClick={onClick} sx={{ cursor: "pointer" }}>
        <Typography sx={titleStyle}>{title}</Typography>
        {subTitles.map((subTitle) => (
          <Typography key={subTitle} sx={subTitleStyle}>
            {subTitle}
          </Typography>
        ))}
      </Box>
      {children && (
        <Box
          sx={{
            // ...childrenStyle,
            overflowX: "hidden",
            overflowY: isOpen ? "auto" : "hidden",
            transition: "max-height 250ms ease, opacity 100ms ease",
            maxHeight: isOpen ? `${openMaxHeight}px` : 0,
            opacity: isOpen ? 1 : 0,
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
          <Box sx={titleChildrenSpace}></Box>
          <Grid container spacing={childrenSpace.space}>
            {children}
          </Grid>
        </Box>
      )}
    </Box>
  );
}
